import { createFileRoute } from '@tanstack/react-router';

import { CompetitionEditPage } from '@/components/admin/sport/competition-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetCompetitionFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/competitions_/$id')({
    component: CompetitionEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'טורניר חדש' : 'עריכת טורניר',
            `/admin/sport/competitions/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetCompetitionFn({ data: { id: params.id } });
    },
});

function CompetitionEditRoute() {
    const data = Route.useLoaderData();
    const key = useAdminEditPageKey(
        data?.competition
            ? `${data.competition.id}:${String(data.competition.updatedAt)}`
            : undefined,
    );
    return <CompetitionEditPage key={key} data={data} />;
}
